import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'
import { ContrastQueryParameters } from '../../../../graphql/schema/endpoint-helpers'
import {
  Organization,
  OrganizationSnakeCase
} from '@contrast-security-inc/base-types'

interface OrganizationsApiResponse extends BaseApiResponse {
  managed: boolean
  organization: OrganizationSnakeCase
}

export interface GetOrganizationsArgs {
  organizationUuid: string
  expandValue?: string
}

export async function getOrganization(
  this: ThisConnector,
  { organizationUuid, expandValue }: GetOrganizationsArgs
): Promise<Organization> {
  const params = new ContrastQueryParameters()
  const expand = expandValue ? expandValue.split(',') : []
  params.append(
    'expand',
    Array.from(new Set(['skip_links', ...expand])).join(',')
  )
  const { organization } = await this.connector.get<OrganizationsApiResponse>(
    `/${organizationUuid}/organizations?${params}`
  )

  return normalizeOrganization(organization)
}

/** Combines organization properties and returns camelCase properties. */
export function normalizeOrganization(
  data: OrganizationSnakeCase
): Organization {
  return {
    ...data,
    // Old properties TBD
    apiOnly: data.api_only,
    cloudnativeEnabled: data.cloudnative_enabled,
    freemium: data.freemium,
    harmonyEnabled: data.harmony_enabled,
    sastEnabled: data.sast_enabled,
    // Normalize properties to camelCase
    betaLanguagesEnabled: data.beta_languages_enabled,
    ossLicense: data.ossLicense,
    organizationUuid: data.organization_uuid,
    orgName: data.getFirstName,
    isHarmonyEnabled: data.harmony_enabled,
    isCloudnativeEnabled: data.cloudnative_enabled,
    isFreemium: data.freemium,
    isSastEnabled: data.sast_enabled,
    name: data.name,
    cvssScoringType: data.cvss_scoring_type,
    isSuperadmin: data.is_superadmin,
    dateFormat: data.date_format,
    timezone: data.timezone,
    timeFormat: data.time_format,
    locale: data.locale,
    creationTime: data.creation_time,
    protectionEnabled: data.protection_enabled,
    autoLicenseProtection: data.auto_license_protection,
    autoLicenseAssessment: data.auto_license_assessment,
    serverEnvironments: data.server_environments,
    appsOnboarded: data.apps_onboarded,
    userProtectionEnabled: data.user_protection_enabled,
    userAccess: data.user_access,
    isApiOnly: data.api_only,
    vulnerabilityTrendsGraphEnabled: data.vulnerability_trends_graph_enabled,
    // Properties object
    preventOnboardingFailingApplications:
      data.properties?.prevent_onboarding_failing_applications === 'true',
    allowEnableImpersonation:
      data.properties?.allow_enable_impersonation === 'true',
    restrictedEditRole: data.properties?.restricted_edit_role === 'true',
    defaultFilteringByMostRecentSession:
      data.properties?.default_filtering_by_most_recent_session === 'true',
    preventOnboardingFailingApplicationsBySession:
      data.properties?.prevent_onboarding_failing_applications_by_session ===
      'true',
    impersonationAllowed: data.properties?.impersonation_allowed === 'true'
  }
}
